module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/review_2-dec5ba2e8ab4aa68c9b34650ad0fd0f8.png";